// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessAction_container__1SNpK","logo":"SuccessAction_logo__1nN9l","text":"SuccessAction_text__2SSE5","done":"SuccessAction_done__2lMsA"};